// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"898e8b83","147":"a1d719cc","235":"93290d4a","257":"63f2a40f","327":"a7ffe9be","341":"1da23275","381":"0f43d47c","842":"ed914c03","982":"9ca8fe42","984":"0825cf85"}[chunkId] + ".chunk.js";
};